import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {observable, makeObservable} from 'mobx';
import {DayPicker} from 'react-day-picker';
import 'react-day-picker/src/style.css';
import moment from 'moment';
import {utilsService} from '../../core/services/utils.service';

@observer
export class DatePicker extends React.Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    handleOnChange: PropTypes.func,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    uniqueSrText: PropTypes.string,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    setHourTo: PropTypes.number,
    utcOffset: PropTypes.string,
    date: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ])
  }

  static defaultProps = {
    uniqueSrText: '',
    required: false,
    disabled: false,
    errorMessage: 'This entry is not valid.',
    className: ''
  }

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  @observable isOpen = false;
  @observable hasVisibleError = false;
  @observable inputValue = '';

  get selectedDate() {
    if (!this.props.date || this.props.date === "CUSTOM" || this.props.date === "IMMEDIATELY") {return undefined}
    if (moment.isMoment(this.props.date)) {return this.props.date.toDate()}
    if (this.props.date === null) {return undefined}
    let date = moment(utilsService.normalizedDate(this.props.date));
    if (this.props.utcOffset) {
      date.utcOffset(this.props.utcOffset);
    }
    return date.toDate();
  }

  handleInputChange = (e) => {
    this.inputValue = e.target.value;
  }

  handleInputBlur = () => {
    if (!this.inputValue) return;
    let momentDate = moment(this.inputValue, ["MM/DD/YYYY"], true);
    if (momentDate.isValid()) {
      this.hasVisibleError = false;
      if (this.props.setHourTo) {
        momentDate.hour(this.props.setHourTo);
      }
      if (this.props.handleOnChange) {
        this.props.handleOnChange(momentDate);
      }
    } else {
      this.hasVisibleError = true;
      if (this.props.handleOnChange) {
        this.props.handleOnChange(null);
      }
    }
  }

  handleDaySelect = (day) => {
    if (!day) return;
    let momentDate = moment(day);
    this.hasVisibleError = false;
    this.inputValue = momentDate.format('MM/DD/YYYY');
    this.isOpen = false;

    if (this.props.setHourTo) {
      momentDate.hour(this.props.setHourTo);
    }
    if (this.props.handleOnChange) {
      this.props.handleOnChange(momentDate);
    }
  }

  toggleCalendar = () => {
    if (!this.props.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  render() {
    const srText = `${this.props.uniqueSrText}; You can type a date in MM/DD/YYYY format, or press the calendar button to pick a date.`;
    const displayValue = this.inputValue || (this.selectedDate ? moment(this.selectedDate).format('MM/DD/YYYY') : '');

    return (
      <div className={`form-group datepicker ${this.props.className} ${this.hasVisibleError ? 'has-error' : ''}`}>
        <div className="msgBlock error error-list date-picker-error">
          <span role={this.hasVisibleError ? 'status' : ''} aria-atomic="true">
            {this.hasVisibleError ? 'Please enter a valid date in the format MM/DD/YYYY.' : ''}
          </span>
        </div>
        <div className="input-group">
          <span className="sr-only" id={`${this.props.id}-sr`}>{srText}</span>
          <input
            id={this.props.id}
            type="text"
            className="form-control DateInput_input"
            placeholder="Custom Date"
            aria-describedby={`${this.props.id}-sr`}
            aria-label="CustomDate"
            disabled={this.props.disabled}
            value={displayValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputBlur}
          />
          <span className="SingleDatePickerInput_calendarIcon" onClick={this.toggleCalendar} role="button" tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') this.toggleCalendar(); }}
            aria-label="Toggle calendar"
          >
            <span className="sr-only">{`${this.props.uniqueSrText}; Press enter to open the calendar.`}</span>
            <span aria-hidden="true" className="icon-calendar"/>
          </span>
          {this.isOpen && !this.props.disabled && (
            <div className="rdp-popover SingleDatePicker_picker">
              <DayPicker
                mode="single"
                selected={this.selectedDate}
                onSelect={this.handleDaySelect}
                defaultMonth={this.selectedDate}
                navLayout="around"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
